import * as React from 'react';
import { SVGProps } from 'react';

const IconWindowSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 10.5h12v2H6v-2ZM6 14.5h6v2H6v-2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 5v13h16V7H4Z"
    />
  </svg>
);
export default IconWindowSizeM;
